//template system
import { templates } from './../templates.js'

//template files
import templateItemMenuLeft from './../../template-parts/ajaxChat/itemMenuLeft.js';
import templateItemMenuThreads from './../../template-parts/ajaxChat/itemMenuThreads.js';
import templateBoxMessage from './../../template-parts/ajaxChat/boxMessage.js';

//dependencies
import { notifications } from './notifications.js'

var ajaxChat = {
  init: function (settings) {
    const el_chat = settings.selector;
    const el_chat_menu = jQuery(el_chat).find(".js-ajax-chat-menu");
    const el_chat_threads = jQuery(el_chat).find(".js-ajax-chat-threads");
    const el_chat_threads_count = jQuery(el_chat).find(".js-ajax-chat-threads-count");
    const el_chat_main = jQuery(el_chat).find(".js-ajax-chat-main");
    const el_chat_main_top_img = jQuery(el_chat).find(".js-ajax-chat-main-top-img");
    const el_chat_main_top_name = jQuery(el_chat).find(".js-ajax-chat-main-top-name");
    const el_chat_main_top_date = jQuery(el_chat).find(".js-ajax-chat-main-top-date");
    const el_chat_window = jQuery(el_chat).find(".js-ajax-chat-window");
    const el_chat_new_message = jQuery(el_chat).find(".js-ajax-chat-new-message");
    const el_chat_new_message_input_group = jQuery(el_chat).find(".js-ajax-chat-new-message-input-group");
    const el_chat_threads_search = jQuery(el_chat).find(".js-ajax-chat-threads-search");
    const el_chat_threads_search_button = jQuery(el_chat).find(".js-ajax-chat-threads-search-button");
    const el_chat_threads_search_input = jQuery(el_chat).find(".js-ajax-chat-threads-search-input");
    const el_chat_threads_search_not_found = jQuery(el_chat).find(".js-ajax-chat-threads-search-not-found");
    const el_chat_threads_reset = jQuery(el_chat).find(".js-ajax-chat-threads-search-reset");
    const el_chat_locked = jQuery(el_chat).find(".js-ajax-chat-locked");
    const el_chat_locked_unlock_button = jQuery(el_chat).find(".js-ajax-chat-locked-unlock-button");
    const el_chat_user_not_activated = jQuery(el_chat).find(".js-ajax-chat-user-not-activated");

    //Chat actions menu
    const el_chat_actions = jQuery(el_chat).find(".js-ajax-chat-actions");
    const el_chat_action_menu = jQuery(el_chat).find(".js-ajax-chat-action-menu");
    const el_chat_action_menu_button = jQuery(el_chat).find(".js-ajax-chat-action-menu-button");
    const el_chat_approve_button = jQuery(el_chat).find(".js-ajax-chat-approve-button");
    const el_chat_disapprove_button = jQuery(el_chat).find(".js-ajax-chat-disapprove-button");
    const el_chat_disapprove_form_select = jQuery(el_chat).find(".js-ajax-chat-disapprove-form-select");
    const el_chat_disapprove_form_custom_reason = jQuery(el_chat).find(".js-ajax-chat-disapprove-form-custom-reason");
    const el_chat_disapprove_form_send = jQuery(el_chat).find(".js-ajax-chat-disapprove-form-send");
    const el_chat_disapprove_by_accomodated_form_send = jQuery(el_chat).find(".js-ajax-chat-disapprove-by-accomodated-form-send");
    const el_chat_change_date = jQuery(el_chat).find(".js-ajax-chat-change-date");
    const el_chat_change_date_button = jQuery(el_chat).find(".js-ajax-chat-change-date-button");
    const el_chat_change_date_button_send = jQuery(el_chat).find(".js-ajax-chat-change-date-button-send");
    const el_chat_send_file = jQuery(el_chat).find(".js-ajax-chat-send-file");
    const el_chat_send_file_button = jQuery(el_chat).find(".js-ajax-chat-send-file-button");
    const el_chat_disapprove_by_accomodated_button = jQuery(el_chat).find(".js-ajax-chat-disapprove-by-accomodated-button");

    let first_load = true;
    let current_chat_menu = 0;
    let current_chat_thread = 0;
    let previous_chat_thread = 0;

    if (typeof ajax_chat_default_chat_menu !== "undefined") current_chat_menu = ajax_chat_default_chat_menu; //settings in ajax-chat.php
    if (typeof ajax_chat_default_chat_thread !== "undefined") current_chat_thread = ajax_chat_default_chat_thread; //settings in ajax-chat.php

    //Checks
    if (jQuery(el_chat).length === 0) {
      return;
    }

    if (typeof settings.ajax_url === "undefined") {
      console.error("Error: ajax_url is not set!");
      return;
    }

    if (jQuery(el_chat).data("show-only-system-messages")) {
      current_chat_menu = 3;
    }

    let doing_ajax = false;
    function reload_all() {
      if (!doing_ajax) {
        doing_ajax = true;

        if (theme.globals.isDevelopment) console.log("doing full reload ajax");

        jQuery.ajax({
          method: "GET",
          url: settings.ajax_url,
          data: {
            action: "ajax_chat",
            ajax_chat_action: "get_all",
            current_chat_menu: current_chat_menu,
            current_chat_thread: current_chat_thread,
            show_only_system_messages: jQuery(el_chat).data("show-only-system-messages"),
            show_only_host: jQuery(el_chat).data("show-only-host"),
          },
          dataType: "json",
        })
          .done(function (data) {
            if (theme.globals.isDevelopment) console.log(data);

            reload_all_from_data(data);

            //refresh
            if (first_load) {
              setInterval(check_for_new_message, 5000);
              first_load = false;
            }
          })
          .fail(function (error) {
            if (typeof error.responseJSON?.data === "string") alert(error.responseJSON.data);
          })
          .always(function () {
            doing_ajax = false;
          });
      }
    }

    function reload_all_from_data(data) {
      //if (theme.globals.isDevelopment) console.log(data);

      //init
      jQuery(el_chat_threads).parent().removeClass("hide");
      jQuery(el_chat_new_message).removeClass("hide");

      //Menu
      let menu_html = "";
      data.menu.forEach((row) => {
        menu_html += templates.renderTemplate(templateItemMenuLeft, {
          id: row.id,
          class_active: (row.active ? 'active' : ''),
          name: row.name,
          new: (row.new ? '<span class="badge">' + sikmoVars.translation.new + '</span>' : ''),
        });
      });

      if (jQuery(el_chat_menu).html() !== menu_html) {
        jQuery(el_chat_menu).html(menu_html);
      } else {
        if (theme.globals.isDevelopment) console.log("menu unchanged.");
      }

      //Threads
      let threads_html = "";
      let active_thread_found = false;
      data.threads.forEach((row) => {
        //console.log( row );

        threads_html += templates.renderTemplate(templateItemMenuThreads, {
          id: row.id,
          class_active: (row.active ? 'active' : ''),
          class_show: (row.unread ? 'show' : ''),
          date_range: row.date_range,
          name: row.name,
          data: `${row.opposite_user_name}, `+ (parseInt(row.persons) > 0 ? row.persons + ', ' : '') +`${row.price}`,
        });

        if (row.active && !active_thread_found) {
          active_thread_found = true;

          //set global variable for calendar
          window.accomodation_currency = row.currency;

          //render accomodation info
          jQuery(el_chat_main_top_img).attr("src", row.img);
          jQuery(el_chat_main_top_name).html(row.name);
          jQuery(el_chat_main_top_date).html( `<span class="id">${row.id}</span> ${row.date_range}, ${row.opposite_user_name}, `+ (parseInt(row.persons) > 0 ? row.persons + ', ' : '') +`${row.price }` );

          //if active threads exists, show chat window
          jQuery(el_chat_main).addClass("show");

          //show/hide host action menu
          if (row.is_user_host && row.is_accommodated_user_activated && row.can_do_actions) {
            jQuery(el_chat_actions).removeClass("hide");
            jQuery(el_chat_approve_button).show();
            jQuery(el_chat_disapprove_button).show();
            jQuery(el_chat_change_date_button).show();
            jQuery(el_chat_send_file_button).show();
            
            jQuery(el_chat_disapprove_by_accomodated_button).hide();

            if (row.is_confirmed) {
              jQuery(el_chat_approve_button).hide();
            }
          } else if (!row.is_user_host && row.can_do_actions && !row.is_confirmed) {
            //Interface for accommodated user (he can disapprove only if accomodation is not confirmed yet)
            jQuery(el_chat_actions).removeClass("hide");
            jQuery(el_chat_approve_button).hide();
            jQuery(el_chat_disapprove_button).hide();
            jQuery(el_chat_change_date_button).hide();
            jQuery(el_chat_send_file_button).hide();

            jQuery(el_chat_disapprove_by_accomodated_button).show();
          } else {
            jQuery(el_chat_actions).addClass("hide");
          }

          //locked chat
          if (!row.is_accommodated_user_activated) {
            jQuery(el_chat_window).addClass("locked");
            jQuery(el_chat_new_message).addClass("hide");
            jQuery(el_chat_locked).removeClass("show");
            jQuery(el_chat_user_not_activated).addClass("show");
          } else if (row.is_locked) {
            jQuery(el_chat_window).addClass("locked");
            jQuery(el_chat_new_message).addClass("hide");
            jQuery(el_chat_locked).addClass("show");
            jQuery(el_chat_user_not_activated).removeClass("show");
          } else {
            jQuery(el_chat_window).removeClass("locked");
            jQuery(el_chat_new_message).removeClass("hide");
            jQuery(el_chat_locked).removeClass("show");
            jQuery(el_chat_user_not_activated).removeClass("show");
          }
        }
      });


      //Threads counter
      if (data.threads.length === 0 || data.threads.length > 1) {
        jQuery(el_chat_threads_count).html(sikmoVars.translation.chat.active_inquiries);
      } else {
        //Only one
        jQuery(el_chat_threads_count).html(sikmoVars.translation.chat.active_inquiry);
      }
      //add number to the threads counter
      jQuery(el_chat_threads_count).children("span").text(data.threads.length);


      //hide chat window if there isn't any active thread
      if (!active_thread_found) jQuery(el_chat_main).removeClass("show");

      if (jQuery(el_chat_threads).html() !== threads_html) {
        jQuery(el_chat_threads).html(threads_html);
      } else {
        if (theme.globals.isDevelopment) console.log("threads unchanged.");
      }

      //show chat window if menu is 'system messages' (and there is no threads)
      if (data.threads.length === 0 && data.chat_window.length > 0) {
        jQuery(el_chat_main).addClass("show");
        jQuery(el_chat_threads).parent().addClass("hide"); //hide threads
        jQuery(el_chat_new_message).addClass("hide"); //hide new message input

        jQuery(el_chat_main_top_name).html("Systémové zprávy");
        jQuery(el_chat_main_top_date).html("");
      }

      //Chat window
      let chat_window_html = "";
      data.chat_window.forEach((row) => {
        chat_window_html += templates.renderTemplate(templateBoxMessage, {
          class_my: (row[1] ? 'my' : 'not-my'),
          text: row[0],
          time: convertTimestampToDateTime(row[2]),
          avatar: row[3],
          class_system: (row[4] ? ' system' : ''),
        });
      });

      if (current_chat_thread !== 0 && previous_chat_thread !== current_chat_thread) update_reserved_dates();

      //Perform HTML DOM update!

      if (jQuery(el_chat_window).html() !== chat_window_html) {
        //insert chats
        jQuery(el_chat_window).html(chat_window_html);

        //scroll chat window to bottom
        if (!jQuery(el_chat_window).hasClass("locked")) {
          jQuery(el_chat_window).scrollTop(jQuery(el_chat_window)[0].scrollHeight);
        } else {
          jQuery(el_chat_window).scrollTop(0);
        }

        //update notification bar (because some messages can be read now)
        notifications.getNotifications();
      } else {
        if (theme.globals.isDevelopment) console.log("chat window unchanged.");
      }

      //reassign events
      reassign_events();

      //close action menu
      toggleActionMenu(true);
    }

    function update_reserved_dates() {
      jQuery.ajax({
        method: "POST",
        url: settings.ajax_url,
        data: {
          action: "ajax_chat",
          ajax_chat_action: "get_reserved_dates",
          current_chat_thread: current_chat_thread
        },
        dataType: "json",
      })
        .done(function (data) {
          if (data.status === "ok") {
            //set into global variables
            window.accomodation_in_progress_dates = data.in_progress_dates;
            window.accomodation_reserved_dates = data.reserved_dates;
            window.accomodation_default_price_per_day = data.default_price_per_day;
            window.accomodation_next_prices_per_day = data.next_prices_per_day;
          }
        })
        .fail(function (error) {
          if (typeof error.responseJSON?.data === "string") alert(error.responseJSON.data);
        })
        .always(function () {
          doing_ajax_post_new = false;
        });
    }

    let doing_ajax_post_new = false;
    function post_new_message() {
      if (!doing_ajax_post_new) {
        doing_ajax_post_new = true;

        let input = jQuery(el_chat_new_message_input_group).find("input");

        jQuery.ajax({
          method: "POST",
          url: settings.ajax_url,
          data: {
            action: "ajax_chat",
            ajax_chat_action: "post_message",
            message: input.val(),
            current_chat_thread: current_chat_thread
          },
          dataType: "json",
        })
          .done(function (data) {
            if (data.status === "ok") {
              input.val(""); //reset input
              //add new message to the chat window
              let add_chat_window_html = templates.renderTemplate(templateBoxMessage, {
                class_my: 'my',
                text: data.message,
                time: convertTimestampToDateTime(data.timestamp),
                avatar: sikmoVars.images.current_user_avatar,
                class_system: '',
              });
              jQuery(el_chat_window).append(add_chat_window_html);

              //scroll chat window to bottom
              jQuery(el_chat_window).scrollTop(jQuery(el_chat_window)[0].scrollHeight);
            } else {
              alert("error2");
            }
          })
          .fail(function (error) {
            if (typeof error.responseJSON?.data === "string") alert(error.responseJSON.data);
          })
          .always(function () {
            doing_ajax_post_new = false;
          });
      }
    }

    function check_for_new_message() {
      jQuery.ajax({
        method: "GET",
        url: settings.ajax_url,
        data: {
          action: "ajax_chat",
          ajax_chat_action: "check_new_message",
          current_chat_menu: current_chat_menu,
          current_chat_thread: current_chat_thread,
          show_only_system_messages: jQuery(el_chat).data("show-only-system-messages"),
          show_only_host: jQuery(el_chat).data("show-only-host"),
        },
        dataType: "json",
      })
        .done(function (data) {
          if (theme.globals.isDevelopment) console.log("Checking for new messages.");
          if (typeof data.no_new_message !== "boolean") {
            if (theme.globals.isDevelopment) console.log("Got new message!");
            //new message, do full reload
            reload_all_from_data(data);
          }
        })
        .fail(function (error) {
          if (typeof error.responseJSON?.data === "string") alert(error.responseJSON.data);
        })
        .always(function () {
          doing_ajax = false;
        });
    }

    function reassign_events() {
      jQuery(el_chat_menu).find("a").off().on("click", function (event) {
        event.preventDefault();

        current_chat_menu = jQuery(this).data("id");
        current_chat_thread = 0;
        reload_all();

        //reset search input
        toggleSearch(true);

        //reset input
        jQuery(el_chat_new_message_input_group).find("input").val("");
      });

      jQuery(el_chat_threads).find("a").off().on("click", function (event) {
        event.preventDefault();

        previous_chat_thread = current_chat_thread;
        current_chat_thread = jQuery(this).data("id");
        reload_all();

        //reset input
        jQuery(el_chat_new_message_input_group).find("input").val("");
      });
    }

    jQuery(el_chat_new_message_input_group).find("svg").on("click", function (event) {
      event.preventDefault();
      if (jQuery(el_chat_new_message_input_group).find("input").val() !== "") {
        post_new_message();
      }
    });

    jQuery(el_chat_new_message_input_group).find("input").on("keypress", function (event) {
      if (event.key === 'Enter') {
        if (jQuery(el_chat_new_message_input_group).find("input").val() !== "") {
          post_new_message();
        }
      }
    });

    jQuery(el_chat_approve_button).on("click", function (event) {
      event.preventDefault();
      if (confirm(sikmoVars.translation.chat.approve_confirm)) {
        approve_appointment();
      }
    });

    jQuery(el_chat_disapprove_form_select).on("input", function (event) {
      const value = jQuery(el_chat_disapprove_form_select).val();
      if (value === "custom") {
        jQuery(el_chat_disapprove_form_custom_reason).addClass("show");
      } else {
        jQuery(el_chat_disapprove_form_custom_reason).removeClass("show");
      }
    });

    jQuery(el_chat_disapprove_form_send).on("click", function (event) {
      event.preventDefault();
      disapprove_appointment();
    });

    jQuery(el_chat_disapprove_by_accomodated_form_send).on("click", function (event) {
      event.preventDefault();
      disapprove_appointment_by_accomodated();
    });

    jQuery(el_chat_change_date_button).on("click", function (event) {
      event.preventDefault();
      if (jQuery(el_chat_change_date_button).hasClass("active")) {
        jQuery(el_chat_change_date_button).removeClass("active");
        jQuery(el_chat_change_date).removeClass("show");
      } else {
        closeAllTabsInActionMenu();

        jQuery(el_chat_change_date_button).addClass("active");
        jQuery(el_chat_change_date).addClass("show");
      }
    });

    jQuery(el_chat_change_date_button_send).on("click", function (event) {
      event.preventDefault();
      change_date_appointment();
    });

    jQuery(el_chat_send_file_button).on("click", function (event) {
      event.preventDefault();
      if (jQuery(el_chat_send_file_button).hasClass("active")) {
        jQuery(el_chat_send_file_button).removeClass("active")
        jQuery(el_chat_send_file).removeClass("show")
      } else {
        closeAllTabsInActionMenu();

        show_form_send_file();
      }
    });

    jQuery(el_chat_action_menu_button).on("click", function (event) {
      event.preventDefault();
      toggleActionMenu();
    });

    function toggleActionMenu(force_close = false) {
      if (jQuery(el_chat_action_menu).hasClass("open") || force_close) {
        //close it
        jQuery(el_chat_change_date_button).removeClass("active");
        jQuery(el_chat_change_date).removeClass("show");

        jQuery(el_chat_send_file_button).removeClass("active");

        jQuery(el_chat_action_menu).removeClass("show");
        jQuery(el_chat_action_menu).removeClass("open");

        jQuery(el_chat_send_file).removeClass("show").html(""); //Empty file upload
      } else {
        //open it
        jQuery(el_chat_action_menu).addClass("open");
        jQuery(el_chat_actions).addClass("hide")
      }
    }

    function closeAllTabsInActionMenu() {
      jQuery(el_chat_send_file_button).removeClass("active");
      jQuery(el_chat_send_file).removeClass("show");

      jQuery(el_chat_change_date_button).removeClass("active");
      jQuery(el_chat_change_date).removeClass("show");
    }

    function convertTimestampToDateTime(unixTimestamp) {
      // Create a new Date object using the Unix timestamp (in milliseconds)
      const date = new Date(unixTimestamp * 1000);

      // Get day, month, year, hours, and minutes
      const day = date.getDate().toString().padStart(2, '0'); // Ensures 2-digit format (e.g., "16")
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensures 2-digit format (e.g., "01"), months are zero-indexed
      const year = date.getFullYear(); // Full year (e.g., "2024")
      const hours = date.getHours().toString().padStart(2, '0'); // Ensures 2-digit format (e.g., "09")
      const minutes = date.getMinutes().toString().padStart(2, '0'); // Ensures 2-digit format (e.g., "24")

      // Return the formatted date and time
      return `${day}. ${month}. ${year}, ${hours}:${minutes}`;
    }

    let doing_ajax_approve = false;
    function approve_appointment() {
      if (!doing_ajax_approve) {
        doing_ajax_approve = true;

        jQuery.ajax({
          method: "POST",
          url: settings.ajax_url,
          data: {
            action: "ajax_chat",
            ajax_chat_action: "approve_appointment",
            current_chat_thread: current_chat_thread,
          },
          dataType: "json",
        })
          .done(function (data) {
            if (data.status === "ok") {
              alert(data.message);
              toggleActionMenu(true);
              window.location.href = "?go_to_thread_id=" + current_chat_thread;
              reload_all();
            } else {
              alert("error3"); //TODO: error handling v celém tomto souboru
            }
          })
          .fail(function (error) {
            if (typeof error.responseJSON?.data === "string") alert(error.responseJSON.data);
          })
          .always(function () {
            doing_ajax_approve = false;
          });
      }
    }

    let doing_ajax_disapprove = false;
    function disapprove_appointment() {
      if (!jQuery(el_chat_disapprove_form_select).val()) {
        alert(sikmoVars.translation.please_select_disapprove_reason);
        return;
      }

      if (jQuery(el_chat_disapprove_form_select).val() === "custom" && jQuery(el_chat_disapprove_form_custom_reason).children("textarea").val() === "") {
        alert(sikmoVars.translation.please_fill_disapprove_reason);
        return;
      }

      let disapprove_reason = jQuery(el_chat_disapprove_form_select).val();
      if (jQuery(el_chat_disapprove_form_select).val() === "custom") {
        disapprove_reason = jQuery(el_chat_disapprove_form_custom_reason).children("textarea").val();
      }

      if (!doing_ajax_disapprove) {
        doing_ajax_disapprove = true;

        jQuery.ajax({
          method: "POST",
          url: settings.ajax_url,
          data: {
            action: "ajax_chat",
            ajax_chat_action: "disapprove_appointment",
            current_chat_thread: current_chat_thread,
            disapprove_reason: disapprove_reason,
          },
          dataType: "json",
        })
          .done(function (data) {
            if (data.status === "ok") {
              alert(data.message);
              toggleActionMenu(true);
              window.location.href = "?go_to_thread_id=" + current_chat_thread;
              reload_all();
            } else {
              alert("error3"); //TODO: error handling v celém tomto souboru
            }
          })
          .fail(function (error) {
            if (typeof error.responseJSON?.data === "string") alert(error.responseJSON.data);
          })
          .always(function () {
            doing_ajax_disapprove = false;
          });
      }
    }

    function disapprove_appointment_by_accomodated() {
      if (!doing_ajax_disapprove) {
        doing_ajax_disapprove = true;

        jQuery.ajax({
          method: "POST",
          url: settings.ajax_url,
          data: {
            action: "ajax_chat",
            ajax_chat_action: "disapprove_appointment_by_accomodated",
            current_chat_thread: current_chat_thread,
          },
          dataType: "json",
        })
          .done(function (data) {
            if (data.status === "ok") {
              alert(data.message);
              toggleActionMenu(true);
              window.location.href = "?go_to_thread_id=" + current_chat_thread;
              reload_all();
            } else {
              alert("error5"); //TODO: error handling v celém tomto souboru
            }
          })
          .fail(function (error) {
            if (typeof error.responseJSON?.data === "string") alert(error.responseJSON.data);
          })
          .always(function () {
            doing_ajax_disapprove = false;
          });
      }
    }

    let doing_ajax_change_date = false;
    function change_date_appointment() {
      if (!doing_ajax_change_date) {
        doing_ajax_change_date = true;

        jQuery.ajax({
          method: "POST",
          url: settings.ajax_url,
          data: {
            action: "ajax_chat",
            ajax_chat_action: "change_date_appointment",
            current_chat_thread: current_chat_thread,
            date_from: jQuery(".js-accomodation-reservation-input-date-from").val(),
            date_to: jQuery(".js-accomodation-reservation-input-date-to").val(),
          },
          dataType: "json",
        })
          .done(function (data) {
            if (data.status === "ok") {
              alert(data.message);
              toggleActionMenu(true);
              window.location.href = "?go_to_thread_id=" + current_chat_thread;
              reload_all();
            } else {
              alert("error4"); //TODO: error handling v celém tomto souboru
            }
          })
          .fail(function (error) {
            if (typeof error.responseJSON?.data === "string") alert(error.responseJSON.data);
          })
          .always(function () {
            doing_ajax_change_date = false;
          });
      }
    }

    let doing_ajax_show_form_send_file = false;
    function show_form_send_file() {
      if (!doing_ajax_show_form_send_file) {
        doing_ajax_show_form_send_file = true;

        jQuery.ajax({
          method: "POST",
          url: settings.ajax_url,
          data: {
            action: "ajax_chat",
            ajax_chat_action: "show_form_send_file",
            current_chat_thread: current_chat_thread,
          },
          dataType: "json",
        })
          .done(function (data) {
            if (data.status === "ok") {
              jQuery(el_chat_send_file).html(data.form);
              jQuery(el_chat_send_file_button).addClass("active");
              jQuery(el_chat_send_file).addClass("show");

              // Reinitialize ACF JS
              if (typeof acf !== 'undefined') {
                acf.doAction('append', jQuery('#acf-form')); // Trigger ACF reinitialization
              }
            } else {
              alert("error6"); //TODO: error handling v celém tomto souboru
            }
          })
          .fail(function (error) {
            if (typeof error.responseJSON?.data === "string") alert(error.responseJSON.data);
          })
          .always(function () {
            doing_ajax_show_form_send_file = false;
          });
      }
    }


    let doing_ajax_unlock_chat_thread = false;
    function unlock_chat_thread() {
      if (!doing_ajax_unlock_chat_thread) {
        doing_ajax_unlock_chat_thread = true;

        jQuery.ajax({
          method: "POST",
          url: settings.ajax_url,
          data: {
            action: "ajax_chat",
            ajax_chat_action: "unlock_chat_thread",
            current_chat_thread: current_chat_thread,
          },
          dataType: "json",
        })
          .done(function (data) {
            if (data.status === "ok") {
              alert(data.message);
              reload_all();
            } else {
              alert("error7"); //TODO: error handling v celém tomto souboru
            }
          })
          .fail(function (error) {
            if (typeof error.responseJSON?.data === "string") alert(error.responseJSON.data);
          })
          .always(function () {
            doing_ajax_unlock_chat_thread = false;
          });
      }
    }

    jQuery(el_chat_threads_reset).on("click", function (event) {
      event.preventDefault();
      toggleSearch(true);
    });

    jQuery(el_chat_threads_search_button).on("click", function (event) {
      event.preventDefault();
      toggleSearch();
    });

    jQuery(el_chat_locked_unlock_button).on("click", function (event) {
      event.preventDefault();
      unlock_chat_thread();
    });

    function toggleSearch(force_close = false) {
      if (jQuery(el_chat_threads_search).hasClass("open") || force_close) {
        jQuery(el_chat_threads_search).removeClass("open");
        jQuery(el_chat_threads_search_input).val("").trigger("input");
      } else {
        jQuery(el_chat_threads_search).addClass("open");
        jQuery(el_chat_threads_search_input).trigger("focus");
      }
    }

    jQuery(el_chat_threads_search_input).on("input", function (event) {
      let search = normalizeText(jQuery(el_chat_threads_search_input).val().toLowerCase());

      if (search == "") {
        jQuery(el_chat_threads).find("a").removeClass("d-none");
        showMessageSearchNotFound();
        return;
      }
    
      jQuery(el_chat_threads).find("a").each(function () {
        let text = normalizeText(jQuery(this).text().toLowerCase());
    
        if (text.includes(search)) {
          jQuery(this).removeClass("d-none");
        } else {
          jQuery(this).addClass("d-none");
        }
      });

      showMessageSearchNotFound();
    });

    function showMessageSearchNotFound() {
      jQuery(el_chat_threads_search_not_found).removeClass("show");

      if (jQuery(el_chat_threads).find("a").length == 0) {
        return;
      }

      if (jQuery(el_chat_threads).find("a:not(.d-none)").length > 0) {
        return;
      }

      //show message
      jQuery(el_chat_threads_search_not_found).addClass("show");
    }
    
    function normalizeText(text) {
      return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    //init
    reload_all();
  },
}

// Export
export { ajaxChat };